import { render, staticRenderFns } from "./StudentCard.vue?vue&type=template&id=45650d07&scoped=true&"
import script from "./StudentCard.vue?vue&type=script&lang=ts&"
export * from "./StudentCard.vue?vue&type=script&lang=ts&"
import style0 from "./StudentCard.vue?vue&type=style&index=0&id=45650d07&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45650d07",
  null
  
)

export default component.exports